"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _Search = _interopRequireDefault(require("./Search"));

var _Menu = _interopRequireDefault(require("./Menu"));

var _HeaderContent = _interopRequireDefault(require("./HeaderContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var HeaderBottom = /*#__PURE__*/function (_Component) {
  _inherits(HeaderBottom, _Component);

  var _super = _createSuper(HeaderBottom);

  function HeaderBottom() {
    _classCallCheck(this, HeaderBottom);

    return _super.apply(this, arguments);
  }

  _createClass(HeaderBottom, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          searchFunction = _this$props.searchFunction,
          children = _this$props.children,
          logosMainDouble = _this$props.logosMainDouble,
          searchPlaceholder = _this$props.searchPlaceholder,
          searchAutocompleteFunction = _this$props.searchAutocompleteFunction,
          searchQuery = _this$props.searchQuery,
          menuLabel = _this$props.menuLabel,
          menuHide = _this$props.menuHide,
          forceUpdateContent = _this$props.forceUpdateContent,
          menuLinksRenderFunction = _this$props.menuLinksRenderFunction,
          _this$props$menuConte = _this$props.menuContent,
          menuContent = _this$props$menuConte === void 0 ? [] : _this$props$menuConte;
      return (0, _preact.h)("div", {
        id: "mtn-header-bottom",
        className: "mtn-o-header-bottom ".concat(logosMainDouble ? 'u-wrapper--double u-wrapper__mobile--double' : 'u-wrapper u-wrapper__mobile')
      }, (0, _preact.h)("div", {
        id: "mtn-header-bottom-container",
        className: "mtn-o-header-bottom__container u-container"
      }, (0, _preact.h)("div", {
        id: "mtn-header-bottom-container-row",
        className: " mtn-grid__row mtn-grid__row--between"
      }, (0, _preact.h)(_HeaderContent["default"], {
        content: children,
        update: forceUpdateContent
      }), (0, _preact.h)("div", {
        className: "mtn-grid__row mtn-grid__row--end"
      }, (0, _preact.h)("div", {
        id: "mtn-header-bottom-menu-section",
        className: "mtn-o-header-bottom__menu"
      }, menuContent.length && !menuHide ? (0, _preact.h)(_Menu["default"], {
        linksRenderFunction: menuLinksRenderFunction,
        label: menuLabel,
        items: menuContent
      }) : null), (0, _preact.h)("div", {
        id: "mtn-header-bottom-search-section",
        className: "mtn-o-header-bottom__search"
      }, searchFunction ? (0, _preact.h)(_Search["default"], {
        searchAutocompleteFunction: searchAutocompleteFunction,
        searchQuery: searchQuery,
        searchFunction: searchFunction,
        searchPlaceholder: searchPlaceholder
      }) : null)))));
    }
  }]);

  return HeaderBottom;
}(_preact.Component);

var _default = HeaderBottom;
exports["default"] = _default;